import { type CoreBrand, type CoreState } from '../../types'

export const SET_BRANDS = (state: CoreState, brands: CoreBrand[]): void => {
  state.brands = brands
}
